import { RadiusTypeEnum } from "../../../utils/helper";
import * as turf from "@turf/turf";
import logo from "../../../assets/images/CrimeRisk.AI Final Logo.png";
import introBgImg from "../../../assets/images/intro-bg-img.jpeg";
import html2pdf from "html2pdf.js";
import { toPng } from "html-to-image";
import JSZip from "jszip";

export class CustomReportClass {
  static demographicsRingMilesHead(i, miles) {
    return `<th style="background: ${
      i % 2 === 0 ? "#43a047" : "#7ed957"
    }; color: #fff; padding: 8px">Ring ${miles}</th>`;
  }

  static demographicsPolygonMilesHead() {
    return `<th style="background:#7ed957; color: #fff; padding: 8px">Custom Trade Area</th>`;
  }

  static demographicsSubHeader = `<tr><td
          colspan="{{length}}"
          style="
            background: #2e3a46;
            color: #fff;
            font-weight: bold;
            padding: 6px;
          "
        >
          {{title}}
        </td></tr>`;

  static demographics5DataWithSubHeading = {
    Population: [
      { value: "POPCY", unit: "" },
      { value: "POPPY", unit: "" },
      { value: "POP20", unit: "" },
      { value: "POP10", unit: "" },
      { value: "GROWCYPY", unit: "%" },
      { value: "GROW10CY", unit: "%" },
      { value: "PDENS", unit: "" },
    ],
    "Non-Residents": [
      { value: "NRPCYTTOT", unit: "" },
      { value: "NRPCYTHTL", unit: "" },
    ],
    Households: [
      { value: "HHDCY", unit: "" },
      { value: "HHDPY", unit: "" },
      { value: "HHD20", unit: "" },
      { value: "HHD10", unit: "" },
      { value: "HGRWCYPY", unit: "%" },
      { value: "HGRW10CY", unit: "%" },
    ],
    Age: [
      { value: "Child5", unit: "%" },
      { value: "Child17", unit: "%" },
      { value: "A1829", unit: "%" },
      { value: "A3044", unit: "%" },
      { value: "A4564", unit: "%" },
      { value: "A6574", unit: "%" },
      { value: "AGT75", unit: "%" },
      { value: "AGECYMED", unit: "" },
    ],
    "Marital Status and Gender": [
      { value: "S1", unit: "%" },
      { value: "S2", unit: "%" },
      { value: "MAR1", unit: "%" },
      { value: "MAR2", unit: "%" },
      { value: "MAR3", unit: "%" },
      { value: "MAR4", unit: "%" },
    ],
    Race: [
      { value: "RC1", unit: "%" },
      { value: "RC2", unit: "%" },
      { value: "RC3", unit: "%" },
      { value: "RC4", unit: "%" },
      { value: "RC5", unit: "%" },
      { value: "RC6", unit: "%" },
      { value: "RC7", unit: "%" },
      { value: "RC8", unit: "" },
      { value: "HISPYHISP", unit: "" },
      { value: "HIS20HISP", unit: "" },
    ],
    "Education (Age 25+)": [
      { value: "E1", unit: "%" },
      { value: "E2", unit: "%" },
      { value: "E3", unit: "%" },
      { value: "E4", unit: "%" },
      { value: "E5", unit: "%" },
      { value: "E6", unit: "%" },
      { value: "E7", unit: "%" },
    ],
    Income: [
      { value: "INCCYAVEHH", unit: "$" },
      { value: "INCCYMEDHH", unit: "$" },
      { value: "INCCYPCAP", unit: "$" },
      { value: "I1", unit: "%" },
      { value: "I2", unit: "%" },
      { value: "I3", unit: "%" },
      { value: "I4", unit: "%" },
      { value: "I5", unit: "%" },
      { value: "I6", unit: "%" },
      { value: "I7", unit: "%" },
      { value: "I8", unit: "%" },
      { value: "I9", unit: "%" },
      { value: "I10", unit: "%" },
      { value: "I11", unit: "%" },
    ],
    Housing: [
      { value: "DWLCY", unit: "" },
      { value: "HOU1", unit: "%" },
      { value: "HOU2", unit: "%" },
      { value: "HOU3", unit: "%" },
    ],
    "Housing Type": [
      { value: "HT1", unit: "%" },
      { value: "HT2", unit: "%" },
      { value: "HT3", unit: "%" },
      { value: "HT4", unit: "%" },
      { value: "HT5", unit: "%" },
      { value: "HT6", unit: "%" },
      { value: "HT7", unit: "%" },
    ],
    "Homes Built By Year": [
      { value: "Y1", unit: "%" },
      { value: "Y2", unit: "%" },
      { value: "Y3", unit: "%" },
      { value: "Y4", unit: "%" },
      { value: "Y5", unit: "%" },
      { value: "Y6", unit: "%" },
      { value: "Y7", unit: "%" },
      { value: "Y8", unit: "%" },
      { value: "YBTEXMED", unit: "" },
      { value: "YR", unit: "" },
    ],
    "Home Values": [
      { value: "V1", unit: "%" },
      { value: "V2", unit: "%" },
      { value: "V3", unit: "%" },
      { value: "V4", unit: "%" },
      { value: "V5", unit: "%" },
      { value: "V6", unit: "%" },
      { value: "V7", unit: "%" },
      { value: "V8", unit: "%" },
      { value: "V9", unit: "%" },
    ],
    Business: [
      { value: "BUSCYEST", unit: "" },
      { value: "BUSCYEMP", unit: "" },
      { value: "AVESZ", unit: "" },
      { value: "AVERE", unit: "" },
    ],
    "Labor Force": [
      { value: "LBFCYPOP16", unit: "" },
      { value: "L1", unit: "%" },
      { value: "L2", unit: "%" },
      { value: "L3", unit: "%" },
      { value: "L4", unit: "%" },
      { value: "LM1", unit: "%" },
      { value: "LF1", unit: "%" },
    ],
    Occupation: [
      { value: "OCC1", unit: "%" },
      { value: "OCC2", unit: "%" },
      { value: "OCC3", unit: "" },
      { value: "OCC4", unit: "" },
      { value: "OCC5", unit: "" },
      { value: "OCC6", unit: "" },
      { value: "OCC7", unit: "" },
      { value: "OCC8", unit: "" },
      { value: "OCC9", unit: "" },
      { value: "OCC10", unit: "" },
      { value: "OCC11", unit: "" },
      { value: "OCC12", unit: "%" },
      { value: "OCC13", unit: "%" },
    ],
    "Transportation to Work": [
      { value: "TRN1", unit: "%" },
      { value: "TRN2", unit: "%" },
      { value: "TRN3", unit: "%" },
      { value: "TRN4", unit: "%" },
      { value: "TRN5", unit: "%" },
      { value: "TRN6", unit: "%" },
      { value: "TVWEXMED", unit: "" },
    ],
  };

  static canadaDemographicsDataWithSubHeading = {
    Population: [{ value: "POPCY", unit: "" }],
    "Population By Sex": [
      { value: "SEXCYFEM", unit: "" },
      { value: "SEXCYMAL", unit: "" },
    ],
    "Population By Age": [
      { value: "AGDCY0004", unit: "" },
      { value: "AGDCY0509", unit: "" },
      { value: "AGDCY1014", unit: "" },
      { value: "AGDCY1519", unit: "" },
      { value: "AGDCY2024", unit: "" },
      { value: "AGDCY2529", unit: "" },
      { value: "AGDCY3034", unit: "" },
      { value: "AGDCY3539", unit: "" },
      { value: "AGDCY4044", unit: "" },
      { value: "AGDCY4549", unit: "" },
      { value: "AGDCY5054", unit: "" },
      { value: "AGDCY5559", unit: "" },
      { value: "AGDCY6064", unit: "" },
      { value: "AGDCY6569", unit: "" },
      { value: "AGDCY7074", unit: "" },
      { value: "AGDCY7579", unit: "" },
      { value: "AGDCY8084", unit: "" },
      { value: "AGDCYGT85", unit: "" },
      { value: "AGECYMED", unit: "" },
    ],
    "Visible Minority": [
      { value: "POPCYVISM", unit: "" },
      { value: "POPCYNVISM", unit: "" },
    ],
    "Educational Attainment": [
      { value: "EDUCYNOHS", unit: "" },
      { value: "EDUCYHS", unit: "" },
      { value: "EDUCYPOST", unit: "" },
      { value: "EDUCYSCOLL", unit: "" },
      { value: "EDUCYTRD", unit: "" },
      { value: "EDUCYNAPP", unit: "" },
      { value: "EDUCYAPP", unit: "" },
      { value: "EDUCYCOLL", unit: "" },
      { value: "EDUCYUNIV", unit: "" },
      { value: "EDUCYGRAD", unit: "" },
      { value: "EDUCYBACH", unit: "" },
      { value: "EDUCYGCERT", unit: "" },
      { value: "EDUCYMED", unit: "" },
      { value: "EDUCYMAST", unit: "" },
      { value: "EDUCYPHD", unit: "" },
    ],
    "Language Spoken": [
      { value: "LNGCYSING", unit: "" },
      { value: "LNGCYOFF", unit: "" },
      { value: "LNGCYENG", unit: "" },
      { value: "LNGCYFRE", unit: "" },
      { value: "LNGNOFF", unit: "" },
      { value: "LNGCYBILEF", unit: "" },
      { value: "LNGCYBILEO", unit: "" },
      { value: "LNGCYBILFO", unit: "" },
      { value: "LNGCYBILBO", unit: "" },
      { value: "HHDCY", unit: "" },
      { value: "HHDCYCPL0", unit: "" },
      { value: "HHDCYMCCH", unit: "" },
      { value: "HHDCYLPF", unit: "" },
      { value: "HHDCYNFM", unit: "" },
    ],
    "Labour Force Status": [
      { value: "LBFCYLBF", unit: "" },
      { value: "LBFCYNILF", unit: "" },
      { value: "LBFCYEMPL", unit: "" },
      { value: "LBFCYUNEMP", unit: "" },
    ],
    "Households By Income": [
      { value: "HINCYLT10", unit: "" },
      { value: "HINCY1020", unit: "" },
      { value: "HINCY2030", unit: "" },
      { value: "HINCY3040", unit: "" },
      { value: "HINCY4050", unit: "" },
      { value: "HINCY5060", unit: "" },
      { value: "HINCY6070", unit: "" },
      { value: "HINCY7080", unit: "" },
      { value: "HINCY8090", unit: "" },
      { value: "HINCY90100", unit: "" },
      { value: "HINCY10050", unit: "" },
      { value: "HINCY15200", unit: "" },
      { value: "HINCYGT200", unit: "" },
      { value: "INCCYMEDHH", unit: "" },
      { value: "INCCYAVEHH", unit: "" },
      { value: "INCCYAVDIS", unit: "" },
    ],
  };

  static demographics1DataWithSubHeading = {
    Population: [
      { value: "POPCY", unit: "" },
      { value: "POP20", unit: "" },
      { value: "AGECYMED", unit: "" },
      { value: "PDENS", unit: "" },
    ],
    Households: [
      { value: "HHDCY", unit: "" },
      { value: "HHD20", unit: "" },
    ],
    Race: [
      { value: "PCT_0001", unit: "%" },
      { value: "PCT_0002", unit: "%" },
      { value: "PCT_0003", unit: "%" },
      { value: "PCT_0004", unit: "%" },
      { value: "PCT_0005", unit: "%" },
      { value: "PCT_0006", unit: "%" },
      { value: "PCT_0007", unit: "%" },
      { value: "PCT_0008", unit: "%" },
    ],
    "Education (Age 25+)": [
      { value: "E1", unit: "%" },
      { value: "E2", unit: "%" },
      { value: "E3", unit: "%" },
      { value: "E4", unit: "%" },
      { value: "E5", unit: "%" },
      { value: "E6", unit: "%" },
      { value: "E7", unit: "%" },
    ],
    Income: [
      { value: "INCCYAVEHH", unit: "$" },
      { value: "INCCYMEDHH", unit: "$" },
      { value: "INCCYPCAP", unit: "$" },
    ],
    Business: [
      { value: "BUSCYEST", unit: "" },
      { value: "BUSCYEMP", unit: "" },
      { value: "AVESZ", unit: "" },
      { value: "AVERE", unit: "" },
    ],
  };

  static environmentDataWithSubHeading = {
    Topography: [
      { value: "NRKELEV", unit: "" },
      { value: "NRKMINELEV", unit: "" },
      { value: "NRKMAXELEV", unit: "" },
      { value: "NRKSLOPE", unit: "" },
      { value: "NRKSLPSTD", unit: "" },
      { value: "NRKTRUGI", unit: "" },
    ],
    "EPA Smart Cities": [
      { value: "SLD22SLC", unit: "" },
      { value: "SLD22WALK", unit: "" },
    ],
    Climate: [
      { value: "TMPAVEANN", unit: "" },
      { value: "TMPMAXANN", unit: "" },
      { value: "TMPMINANN", unit: "" },
      { value: "TMPAVEJAN", unit: "" },
      { value: "TMPMAXJAN", unit: "" },
      { value: "TMPMINJAN", unit: "" },
      { value: "TMPAVEJUL", unit: "" },
      { value: "TMPMAXJUL", unit: "" },
      { value: "TMPMINJUL", unit: "" },
      { value: "PREANNRAIN", unit: "" },
      { value: "PREANNSNOW", unit: "" },
    ],
    "Cooling and Heating Degree Days": [
      { value: "DEGDAYCOOL", unit: "" },
      { value: "DEGDAYHEAT", unit: "" },
    ],
    "Air Quality Indexes": [
      { value: "OZONE", unit: "" },
      { value: "CARBMONO", unit: "" },
      { value: "LEAD", unit: "" },
      { value: "NO2", unit: "" },
      { value: "PM10", unit: "" },
    ],
    "Risk Grades": [
      { value: "TC1", unit: "" },
      { value: "TC2", unit: "" },
      { value: "TC3", unit: "" },
      { value: "TC4", unit: "" },
      { value: "TC5", unit: "" },
      { value: "TC6", unit: "" },
      { value: "TC7", unit: "" },
      { value: "TC8", unit: "" },
      { value: "TC9", unit: "" },
      { value: "TC10", unit: "" },
    ],
    "Environmental Risks": [
      { value: "NRKWRSKI", unit: "" },
      { value: "NRKHURI", unit: "" },
      { value: "NRKTORI", unit: "" },
      { value: "NRKHAILI", unit: "" },
      { value: "NRKWINDI", unit: "" },
      { value: "NRKWFRI", unit: "" },
      { value: "NRKQUKI", unit: "" },
      { value: "NRKSEALVLI", unit: "" },
      { value: "NRKSTMSGI", unit: "" },
      { value: "NRKTSNMI", unit: "" },
    ],
    "Solar Potential (kWh/sq meter)": [
      { value: "DNI22ANN", unit: "" },
      { value: "GHI22ANN", unit: "" },
      { value: "LAT22ANN", unit: "" },
    ],
    "Monthly Direct Normal Irradiance": [
      { value: "DNI22JAN", unit: "" },
      { value: "DNI22FEB", unit: "" },
      { value: "DNI22MAR", unit: "" },
      { value: "DNI22APR", unit: "" },
      { value: "DNI22MAY", unit: "" },
      { value: "DNI22JUN", unit: "" },
      { value: "DNI22JUL", unit: "" },
      { value: "DNI22AUG", unit: "" },
      { value: "DNI22SEP", unit: "" },
      { value: "DNI22OCT", unit: "" },
      { value: "DNI22NOV", unit: "" },
      { value: "DNI22DEC", unit: "" },
    ],
  };

  static introData(template, type) {
    const projectionYear = new Date().getFullYear() + 5;
    const data =
      type === "crime"
        ? {
            title: "Crime",
            description: `The CrimeRisk multiplier represents how the likelihood of crime at a given location compares to the national average (1.00).<br>
                Values above 1.00 denote an increased probability of crime occurrence (1.20 indicates a 20% higher likelihood than the national baseline).<br>
                Values below 1.00 denote a reduced probability (0.80 indicates a 20% lower likelihood).`,
          }
        : type === "environment"
        ? {
            title: "Environmental",
            description: `This report provides a site-focused overview of environmental exposure, including
                climate normals, degree days, air quality, EPA Smart Location and walkability,
                plant hardiness zones, solar potential, and topography. Standardized hazard
                scores for tornado, hail, damaging winds, wildfire, earthquake, sea level rise,
                storm surge, and tsunami allow quick comparison, with air quality benchmarked to
                a U.S. average of 100 and risks reported on a 0–10 scale.`,
          }
        : {
            title: "Demographics",
            description: `Key Demographics delivers a concise, site centered profile of the people and
                economic activity around your chosen location. The tables organize population
                and households, age, race and education, income, housing and home values,
                business mix, labor force, and commute patterns, with current estimates and ${projectionYear}
                projections so you can quickly understand who lives, works, and spends in the
                area you select.`,
          };

    return template
      .replace("{{title}}", data.title)
      .replace("{{description}}", data.description);
  }

  static takeCroppedRadiusScreenshot({ map, name, coordinates }) {
    const mapCanvas = map.getCanvas();
    const dataURL = mapCanvas.toDataURL("image/png");
    const ringLayerIds = [name, `${name}-line`];
    // Step 1: Hide all layers except ring
    const layers = map.getStyle().layers;
    const hiddenLayers = [];
    layers.forEach((layer) => {
      const isRingLayer = ringLayerIds.includes(layer.id);
      const visibility = map.getLayoutProperty(layer.id, "visibility");
      if (!isRingLayer && visibility !== "none") {
        map.setLayoutProperty(layer.id, "visibility", "none");
        hiddenLayers.push(layer.id);
      }
    });
    // Wait for redraw
    map.once("idle", () => {
      // Step 2: Calculate bbox of ring
      const ringCoordinates = coordinates.features
        ? coordinates.features[0].geometry.coordinates[0]
        : coordinates.geometry.coordinates[0];
      let minLng = Infinity,
        minLat = Infinity,
        maxLng = -Infinity,
        maxLat = -Infinity;
      ringCoordinates.forEach(([lng, lat]) => {
        minLng = Math.min(minLng, lng);
        minLat = Math.min(minLat, lat);
        maxLng = Math.max(maxLng, lng);
        maxLat = Math.max(maxLat, lat);
      });
      // Step 3: Project to pixels
      const nw = map.project([minLng, maxLat]);
      const se = map.project([maxLng, minLat]);
      const padding = 20;
      const cropX = Math.max(0, nw.x - padding);
      const cropY = Math.max(0, nw.y - padding);
      const cropWidth = Math.min(
        mapCanvas.width - cropX,
        se.x - nw.x + 2 * padding
      );
      const cropHeight = Math.min(
        mapCanvas.height - cropY,
        se.y - nw.y + 2 * padding
      );
      // Step 4: Draw the WebGL canvas image onto a new 2D canvas
      const img = new Image();
      img.onload = () => {
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = cropWidth;
        tempCanvas.height = cropHeight;
        const tempCtx = tempCanvas.getContext("2d");
        tempCtx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
        // Step 5: Download
        const croppedDataUrl = tempCanvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = croppedDataUrl;
        link.download = `${name}-radius-cropped.png`;
        link.click();
        // Step 6: Restore all hidden layers
        hiddenLayers.forEach((layerId) => {
          map.setLayoutProperty(layerId, "visibility", "visible");
        });
      };
      img.src = dataURL;
    });
  }

  static async captureCircleArea({
    map,
    circleLayerIds,
    coordinates,
    imgUrls,
    targetAspect, // optional: width/height of the destination box.
    // When set, the crop is expanded around the ring's centre so the
    // returned image already matches the report container's aspect.
    // When unset, behaviour is the original square bbox crop.
  }) {
    await new Promise((resolve) => {
      const bbox = turf.bbox(coordinates);
      // When an aspect is requested, fit the ring into a box small enough that a
      // targetAspect-shaped crop centred on it still fits inside the screenshot.
      // Fixed padding used to leave big rings filling the viewport height, so the
      // crop hit the screenshot edge, got clamped to some other aspect, and then
      // html2canvas (1.4.1 honours object-fit unreliably) stretched it to fill the
      // 2.8 box — the wider the ring, the worse the distortion.
      // Captured frame height = ring diameter × this, i.e. a clear margin of
      // (RING_CONTEXT - 1) / 2 of the diameter above and below the circle. 1.5
      // leaves 25% each side, so the ring sits comfortably inside the report's
      // map panel instead of touching (or crossing) its edge.
      const RING_CONTEXT = 1.5;
      let padding = { top: 50, bottom: 50, left: 50, right: 50 };
      if (targetAspect) {
        const el = map.getContainer();
        const cw = el.clientWidth;
        const ch = el.clientHeight;
        // Hold the ring small enough on screen that the frame around it —
        // ring × RING_CONTEXT tall, and targetAspect times that wide — still
        // fits inside the screenshot, with 10% slack. Both axes matter: width
        // binds on normal displays, height on very wide ones.
        const ringExtent = Math.max(
          80,
          0.9 *
            Math.min(cw / (RING_CONTEXT * targetAspect), ch / RING_CONTEXT)
        );
        // Equal available extents on both axes → fitBounds sizes the (square)
        // ring bbox to ringExtent rather than to whichever axis is roomier.
        padding = {
          top: Math.max(16, (ch - ringExtent) / 2),
          bottom: Math.max(16, (ch - ringExtent) / 2),
          left: Math.max(16, (cw - ringExtent) / 2),
          right: Math.max(16, (cw - ringExtent) / 2),
        };
      }

      // Hide only the circle layer(s)
      circleLayerIds.forEach((layerId) => {
        if (map.getLayer(layerId)) {
          map.setLayoutProperty(layerId, "visibility", "none");
        }
      });

      map.fitBounds(
        [
          [bbox[0], bbox[1]],
          [bbox[2], bbox[3]],
        ],
        { padding, animate: false }
      );

      map.once("idle", async () => {
        const mapContainer = map.getContainer();

        // Screenshot at high resolution
        const pixelRatio = 3;
        const dataURL = await toPng(mapContainer, { pixelRatio });

        // Get updated pixel bounds AFTER fit
        const sw = map.project([bbox[0], bbox[1]]);
        const ne = map.project([bbox[2], bbox[3]]);

        // Scale coords for high DPI
        let cropX = sw.x * pixelRatio;
        let cropY = ne.y * pixelRatio;
        let cropWidth = (ne.x - sw.x) * pixelRatio;
        let cropHeight = (sw.y - ne.y) * pixelRatio;

        const fullW = mapContainer.clientWidth * pixelRatio;
        const fullH = mapContainer.clientHeight * pixelRatio;

        // Crop
        const img = new Image();
        img.src = dataURL;
        await new Promise((res) => (img.onload = res));

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (targetAspect) {
          // Emit an image that is EXACTLY targetAspect, doing the "cover" fit
          // ourselves rather than leaning on CSS object-fit: html2canvas 1.4.1
          // honours object-fit inconsistently and stretches the image to the
          // element box, so anything other than the exact aspect shows up as
          // visible distortion in the PDF (worst on the widest ring).
          const outH = Math.floor(Math.min(fullH, fullW / targetAspect));
          const outW = Math.round(outH * targetAspect);
          // Match the source window to the ROUNDED output aspect, not to
          // targetAspect — otherwise integer canvas dimensions reintroduce a
          // tiny (sub-pixel, but needless) non-uniform scale.
          const outAspect = outW / outH;

          // Source window: same aspect as the output, centred on the ring, and
          // RING_CONTEXT× the circle's own size so there is real map around it.
          // Same factor the fitBounds padding above was sized from, so the two
          // agree and the window never has to be shrunk to fit.
          const cx = cropX + cropWidth / 2;
          const cy = cropY + cropHeight / 2;
          let srcH =
            Math.max(cropHeight, cropWidth / outAspect) * RING_CONTEXT;
          let srcW = srcH * outAspect;

          // If it overflows the screenshot, shrink BOTH axes by the same factor
          // so the aspect is preserved (the old code trimmed one axis, which is
          // exactly what broke it), then slide it back inside the bounds.
          const fit = Math.min(1, fullW / srcW, fullH / srcH);
          srcW *= fit;
          srcH *= fit;
          const srcX = Math.max(0, Math.min(cx - srcW / 2, fullW - srcW));
          const srcY = Math.max(0, Math.min(cy - srcH / 2, fullH - srcH));

          canvas.width = outW;
          canvas.height = outH;
          // srcW/srcH === outW/outH, so this scale is uniform — never distorts.
          ctx.drawImage(img, srcX, srcY, srcW, srcH, 0, 0, outW, outH);
        } else {
          canvas.width = cropWidth;
          canvas.height = cropHeight;
          ctx.drawImage(
            img,
            cropX,
            cropY,
            cropWidth,
            cropHeight,
            0,
            0,
            cropWidth,
            cropHeight
          );
        }

        // Save
        const croppedDataURL = canvas.toDataURL("image/png");
        imgUrls.push(croppedDataURL);
        circleLayerIds.forEach((layerId) => {
          if (map.getLayer(layerId)) {
            map.setLayoutProperty(layerId, "visibility", "visible");
          }
        });
        resolve();
      });
    });
  }

  static async capturePolygonArea({
    map,
    polygonGeoJSON,
    imgUrls,
    hiddenLayerIds = [],
    size = 600, // final square output
    extraMarginFactor = 1.3, // zooms out a bit for tall/narrow shapes
  }) {
    return new Promise((resolve) => {
      const bbox = turf.bbox(polygonGeoJSON);
      let [minX, minY, maxX, maxY] = bbox;

      const width = maxX - minX;
      const height = maxY - minY;

      // Center point of the polygon
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;

      // ✅ Make bbox square
      let halfSide = Math.max(width, height) / 2;

      // ✅ Expand a bit more for tall/narrow shapes
      if (height / width > 1.2 || width / height > 1.2) {
        halfSide *= extraMarginFactor;
      }

      minX = centerX - halfSide;
      maxX = centerX + halfSide;
      minY = centerY - halfSide;
      maxY = centerY + halfSide;

      const squareBbox = [minX, minY, maxX, maxY];

      // Hide layers
      hiddenLayerIds.forEach((layerId) => {
        if (map.getLayer(layerId)) {
          map.setLayoutProperty(layerId, "visibility", "none");
        }
      });

      // Fit to expanded square bbox
      map.fitBounds(
        [
          [squareBbox[0], squareBbox[1]],
          [squareBbox[2], squareBbox[3]],
        ],
        { padding: 50, animate: false }
      );

      map.once("idle", async () => {
        const pixelRatio = 3;
        const dataURL = await toPng(map.getContainer(), { pixelRatio });

        const sw = map.project([squareBbox[0], squareBbox[1]]);
        const ne = map.project([squareBbox[2], squareBbox[3]]);

        const cropX = sw.x * pixelRatio;
        const cropY = ne.y * pixelRatio;
        const cropWidth = (ne.x - sw.x) * pixelRatio;
        const cropHeight = (sw.y - ne.y) * pixelRatio;

        const img = new Image();
        img.src = dataURL;
        await new Promise((res) => (img.onload = res));

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const squareSize = size * pixelRatio;
        canvas.width = squareSize;
        canvas.height = squareSize;

        // Keep polygon centered with full coverage
        const scale = Math.max(squareSize / cropWidth, squareSize / cropHeight);
        const drawWidth = cropWidth * scale;
        const drawHeight = cropHeight * scale;
        const offsetX = (squareSize - drawWidth) / 2;
        const offsetY = (squareSize - drawHeight) / 2;

        ctx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          offsetX,
          offsetY,
          drawWidth,
          drawHeight
        );

        const finalDataURL = canvas.toDataURL("image/png");
        imgUrls.push(finalDataURL);

        hiddenLayerIds.forEach((layerId) => {
          if (map.getLayer(layerId)) {
            map.setLayoutProperty(layerId, "visibility", "visible");
          }
        });

        resolve(finalDataURL);
      });
    });
  }

  static async _takeHighQualityScreenshot({ map, name, coordinates, imgUrls }) {
    await new Promise((resolve) => {
      const bbox = turf.bbox(coordinates);
      const padding = { top: 50, bottom: 50, left: 50, right: 50 };
      //   const ringLayerIds = [name, `${name}-line`];
      //   console.log("===>", ringLayerIds);

      map.fitBounds(
        [
          [bbox[0], bbox[1]],
          [bbox[2], bbox[3]],
        ],
        { padding, animate: false }
      );

      map.once("idle", async () => {
        const mapCanvas = map.getCanvas();
        const dataURL = mapCanvas.toDataURL("image/png");

        const img = new Image();
        img.onload = () => {
          const nw = map.project([bbox[0], bbox[3]]);
          const se = map.project([bbox[2], bbox[1]]);

          const cropPadding = 30;
          const cropX = nw.x - cropPadding;
          const cropY = nw.y - cropPadding;
          const cropWidth = se.x - nw.x + cropPadding * 2;
          const cropHeight = se.y - nw.y + cropPadding * 2;

          const outputCanvas = document.createElement("canvas");
          outputCanvas.width = 500;
          outputCanvas.height = 500;
          const ctx = outputCanvas.getContext("2d");

          const scale = Math.min(500 / cropWidth, 500 / cropHeight);
          const offsetX = (500 - cropWidth * scale) / 2;
          const offsetY = (500 - cropHeight * scale) / 2;

          ctx.drawImage(
            img,
            cropX,
            cropY,
            cropWidth,
            cropHeight,
            offsetX,
            offsetY,
            cropWidth * scale,
            cropHeight * scale
          );

          const finalImage = outputCanvas.toDataURL("image/png");
          imgUrls.push(finalImage);
          resolve();
        };
        img.src = dataURL;
      });
    });
  }

  static async fetchHTML(url) {
    const response = await fetch(url);

    return await response.text();
  }

  // Replace every <link rel="stylesheet"> in the parsed document with an
  // inline <style>. html2pdf snapshots synchronously after we hand it the
  // DOM, so async stylesheet loads would race and produce unstyled output.
  static async inlineStylesheets(doc) {
    const links = Array.from(
      doc.querySelectorAll('link[rel="stylesheet"]')
    );
    await Promise.all(
      links.map(async (link) => {
        const href = link.getAttribute("href");
        if (!href) return;
        const resolved = /^(https?:|\/|data:)/.test(href)
          ? href
          : "/" + href.replace(/^\.?\//, "");
        try {
          const res = await fetch(resolved);
          if (!res.ok) return;
          const css = await res.text();
          const style = doc.createElement("style");
          style.textContent = css;
          link.parentNode.replaceChild(style, link);
        } catch (e) {
          // leave the <link> in place if fetch fails; appendPage will still
          // copy it and the browser can try to load it async.
        }
      })
    );
  }

  static appendPage(container, contentDoc, opts = {}) {
    const { addPageBreak = true } = opts;
    const wrapper = document.createElement("div");

    // Pull any <link rel="stylesheet"> or inline <style> out of the template's
    // <head> so the branded CSS applies inside html2pdf's render context.
    // Rewrite relative `href`/`src` URLs to absolute so they resolve against
    // the app origin, not the ephemeral wrapper.
    const headAssets = contentDoc.head
      ? contentDoc.head.querySelectorAll('link[rel="stylesheet"], style')
      : [];
    headAssets.forEach((node) => {
      const clone = node.cloneNode(true);
      if (clone.tagName === "LINK" && clone.getAttribute("href")) {
        const href = clone.getAttribute("href");
        if (!/^(https?:|\/|data:)/.test(href)) {
          clone.setAttribute("href", "/" + href.replace(/^\.?\//, ""));
        }
      }
      wrapper.appendChild(clone);
    });

    wrapper.insertAdjacentHTML("beforeend", contentDoc.body.innerHTML);
    wrapper.classList.add("pdf-page");
    container.appendChild(wrapper);

    // Callers with their own page-break mechanism (e.g. a template's .page
    // with `@media print { page-break-after: always }`) pass addPageBreak:
    // false to avoid double breaks that produce blank pages.
    if (addPageBreak) {
      const breakDiv = document.createElement("div");
      breakDiv.classList.add("html2pdf__page-break");
      container.appendChild(breakDiv);
    }
  }

  static crimeNationalAverageConvertor(value) {
    return `${Number(value / 100).toFixed(2)} ${
      value > 100
        ? "🔺"
        : '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="10px" height="8.89px" viewBox="0 0 270 240"><polygon points="5,5 135,230 265,5" fill="#01bf04" /></svg>'
    } <span style="font-size: 10px">x National Avg.</span>`;
  }

  static formatIndexScore(value) {
    if (value === undefined || value === null || value === "") return "—";
    const n = Number(value);
    return Number.isFinite(n) ? Math.round(n).toLocaleString("en-US") : "—";
  }

  static formatMultiplier(value) {
    if (value === undefined || value === null || value === "") return "—";
    const n = Number(value) / 100;
    return Number.isFinite(n) ? n.toFixed(2) : "—";
  }

  static formatInt(value) {
    if (value === undefined || value === null || value === "") return "—";
    const n = Number(value);
    return Number.isFinite(n) ? Math.round(n).toLocaleString("en-US") : "—";
  }

  /* The 5-year projection tables put two columns (Multiplier + Index Score)
     next to each other per ring. Past three rings the columns get too narrow
     to read on the 1200px page, so the projections page covers only the three
     smallest rings — fewer if the user picked fewer. Cover pages are NOT
     capped; every selected ring gets one. */
  static PROJECTION_MAX_RINGS = 3;

  /* "1" / ".25" / "1.5" / "3" — drop the trailing ".00" on whole miles and
     keep the leading-dot style for sub-mile radii. */
  static formatRingMiles(radius) {
    const v = Number(radius);
    if (!Number.isFinite(v)) return "";
    if (Number.isInteger(v)) return String(v);
    return v
      .toFixed(2)
      .replace(/^0/, "")
      .replace(/0$/, "");
  }

  /* "1 Mile" / ".25 Mile" / "3 Miles" — used for the cover subtitle and the
     projection table's radius headers so both read the same way. */
  static formatRingLabel(radius) {
    const v = Number(radius);
    const miles = this.formatRingMiles(radius);
    if (miles === "") return "";
    return `${miles} ${v === 1 ? "Mile" : "Miles"}`;
  }

  /* Fills one cover page for ONE ring. Called once per selected ring — every
     value is read at `ringKey`, so the page is entirely scoped to that radius. */
  static crimeRiskCoverHTMLMapValues({
    template,
    address,
    ringLabel,
    ringKey,
    crimeData,
    demoData,
    country,
  }) {
    const now = new Date();
    const creationDate = now.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    // Current-year label for CY population figures — always the calendar year the
    // report is generated in (projections roll to +5 elsewhere).
    const populationYear = now.getFullYear();

    const resolveCY = (code) => {
      if (code === "CRMCYRAPE" && !crimeData[code]) return crimeData["CRMCYSAST"];
      return crimeData[code];
    };

    const crimeVars = [
      "CRMCYTOTC",
      "CRMCYPERC",
      "CRMCYPROC",
      "CRMCYMURD",
      "CRMCYRAPE",
      "CRMCYROBB",
      "CRMCYASST",
      "CRMCYBURG",
      "CRMCYLARC",
      "CRMCYMVEH",
    ];

    const popcyRaw =
      resolveCY("POPCY")?.[ringKey] ?? demoData["POPCY"]?.[ringKey];

    const isCanada = (country ?? "").toString().toUpperCase() === "CAN";
    const rapeLabel = isCanada ? "Sexual Assault" : "Rape";

    let result = template
      .replace(/{{address}}/g, address)
      .replace(/{{radius_label}}/g, ringLabel)
      .replace(/{{creation_date}}/g, creationDate)
      .replace(/{{population_year}}/g, String(populationYear))
      .replace(/{{rape_label}}/g, rapeLabel)
      .replace(/{{POPCY}}/g, this.formatInt(popcyRaw))
      .replace(
        /{{AGECYMED}}/g,
        this.formatInt(
          demoData["AGECYMED"]?.[ringKey] ?? crimeData["AGECYMED"]?.[ringKey]
        )
      )
      .replace(
        /{{INCCYAVEHH}}/g,
        // Fall back to the crime CSV (US crime has INCCYAVEHH); Canada crime
        // (can_crm) has no avg HH income, so fall back to median HH income.
        this.formatInt(
          demoData["INCCYAVEHH"]?.[ringKey] ??
            crimeData["INCCYAVEHH"]?.[ringKey] ??
            crimeData["INCCYMEDHH"]?.[ringKey]
        )
      );

    crimeVars.forEach((code) => {
      const row = resolveCY(code);
      const raw = row?.[ringKey];
      result = result
        .replace(
          new RegExp(`{{${code}_IDX}}`, "g"),
          this.formatIndexScore(raw)
        )
        .replace(
          new RegExp(`{{${code}_MUL}}`, "g"),
          this.formatMultiplier(raw)
        );
    });

    return result;
  }

  static crimeRiskProjectionsHTMLMapValues({
    template,
    address,
    rings,
    crimeData,
    country,
  }) {
    // Caller already caps this to PROJECTION_MAX_RINGS; sort defensively so the
    // columns read smallest→largest regardless of the order handed in.
    const sortedRings = [...rings]
      .sort((a, b) => parseFloat(a.defaultRadius) - parseFloat(b.defaultRadius))
      .slice(0, this.PROJECTION_MAX_RINGS);

    const radiusHeaders = sortedRings
      .map((r) => `<th colspan="2">${this.formatRingLabel(r.defaultRadius)}</th>`)
      .join("");
    const metricHeaders = sortedRings
      .map(() => `<th>Multiplier</th><th>Index Score</th>`)
      .join("");
    const colSpan = 1 + sortedRings.length * 2;

    // Fixed-width columns shared by all three projection tables (see .proj-table
    // in styles.css): one label column, then two equal metric columns per ring.
    // The label column widens as rings drop off so the metric columns stay in a
    // readable band instead of stretching to half the page at one ring:
    //   3 rings → 20% label / 13.3% per metric col
    //   2 rings → 34% label / 16.5%
    //   1 ring  → 52% label / 24%
    const labelWidthByRingCount = { 1: 52, 2: 34, 3: 20 };
    const labelPct = labelWidthByRingCount[sortedRings.length] ?? 20;
    const metricPct = sortedRings.length
      ? (100 - labelPct) / (sortedRings.length * 2)
      : 0;
    const metricCols = sortedRings
      .map(
        () =>
          `<col style="width:${metricPct.toFixed(
            4
          )}%" /><col style="width:${metricPct.toFixed(4)}%" />`
      )
      .join("");
    const projColgroup = `<colgroup><col class="proj-col-label" style="width:${labelPct}%" />${metricCols}</colgroup>`;

    const resolvePY = (code) => {
      if (code === "CRMPYRAPE" && !crimeData[code])
        return crimeData["CRMPYSAST"];
      return crimeData[code];
    };

    const buildRow = (label, code) => {
      const row = resolvePY(code);
      const cells = sortedRings
        .map((r) => {
          const ringKey = `RING_${Number(r.defaultRadius).toFixed(2)}`;
          const raw = row?.[ringKey];
          return `<td class="bold">${this.formatMultiplier(
            raw
          )}x</td><td>${this.formatIndexScore(raw)}</td>`;
        })
        .join("");
      return `<tr><td>${label}</td>${cells}</tr>`;
    };

    const overallBody = [
      buildRow("Total Crime Risk", "CRMPYTOTC"),
      buildRow("Personal Crime Risk", "CRMPYPERC"),
      buildRow("Property Crime Risk", "CRMPYPROC"),
    ].join("\n");

    const isCanada = (country ?? "").toString().toUpperCase() === "CAN";
    const rapeLabel = isCanada ? "Sexual Assault" : "Rape";

    const personalBody = [
      buildRow("Murder", "CRMPYMURD"),
      buildRow(rapeLabel, "CRMPYRAPE"),
      buildRow("Robbery", "CRMPYROBB"),
      buildRow("Assault", "CRMPYASST"),
    ].join("\n");

    const propertyBody = [
      buildRow("Burglary", "CRMPYBURG"),
      buildRow("Larceny", "CRMPYLARC"),
      buildRow("Motor Vehicle Theft", "CRMPYMVEH"),
    ].join("\n");

    return template
      .replace(/{{address}}/g, address)
      .replace(/{{proj_col_span}}/g, String(colSpan))
      .replace(/{{proj_colgroup}}/g, projColgroup)
      .replace(/{{radius_headers}}/g, radiusHeaders)
      .replace(/{{metric_headers}}/g, metricHeaders)
      .replace(/{{projections_overall_body}}/g, overallBody)
      .replace(/{{projections_personal_body}}/g, personalBody)
      .replace(/{{projections_property_body}}/g, propertyBody);
  }

  static crimePolygonHTMLMapValues(template, name, csvData) {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
      const trimmedKey = key.trim();
      if (trimmedKey.includes("_DESC")) {
        const nKey = trimmedKey.replace("_DESC", "");
        let value = csvData[nKey]?.DESCRIPTION;
        if (nKey === "CRMCYRAPE" && !value) {
          value = csvData["CRMCYSAST"]?.DESCRIPTION;
        }
        return value ?? "";
      } else {
        let value = csvData[trimmedKey];
        if (trimmedKey === "CRMCYRAPE" && !value) {
          value = csvData["CRMCYSAST"];
        }
        return value && value[name]
          ? this.crimeNationalAverageConvertor(value[name])
          : "";
      }
    });
  }

  static crimeRingHTMLMapValues(template, radiusSetting, csvData) {
    return template
      .replaceAll("__miles__", radiusSetting.defaultRadius)
      .replace(/{{(.*?)}}/g, (_, key) => {
        const trimmedKey = key.trim();
        if (trimmedKey.includes("_DESC")) {
          const nKey = trimmedKey.replace("_DESC", "");
          let value = csvData[nKey]?.DESCRIPTION;
          if (nKey === "CRMCYRAPE" && !value) {
            value = csvData["CRMCYSAST"]?.DESCRIPTION;
          }
          return value ?? "";
        } else {
          let value = csvData[trimmedKey];
          if (trimmedKey === "CRMCYRAPE" && !value) {
            value = csvData["CRMCYSAST"];
          }
          return value &&
            value[`RING_${Number(radiusSetting.defaultRadius).toFixed(2)}`]
            ? this.crimeNationalAverageConvertor(
                value[`RING_${Number(radiusSetting.defaultRadius).toFixed(2)}`]
              )
            : "";
        }
      });
  }

  static createRingDemographicsHeader(template, radiiSetting) {
    const headers = [];
    for (let i = 0; i < radiiSetting.length; i++) {
      headers.push(
        this.demographicsRingMilesHead(
          i,
          Number(radiiSetting[i].defaultRadius).toFixed(2)
        )
      );
    }
    return template.replaceAll("__miles_heading__", headers.join(""));
  }

  static createPolygonDemographicsHeader(template, title) {
    return template.replaceAll(
      "__miles_heading__",
      this.demographicsPolygonMilesHead(title)
    );
  }

  static setMeasurement(data, unit) {
    return unit === "$" ? `${unit}${data}` : `${data}${unit}`;
  }

  static saveAs(zipBlob) {
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CrimeRisk.ai Reports.zip";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  static async generatePDFsAndZip(pages, types, address) {
    const zip = new JSZip();

    for (let i = 0; i < pages.length; i++) {
      const container = pages[i]; // each container = prepared DOM element

      // Containers can set `container.__pdfOpt` to override the default
      // jsPDF/html2canvas opts. Used by the new crime report so its
      // 1200×750 CSS-pixel .page maps 1:1 to a 1200×750-px PDF page.
      const override = container.__pdfOpt ?? {};
      const opt = {
        margin: 0,
        filename: `${types[i]} Report - ${address}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 3, ...(override.html2canvas ?? {}) },
        jsPDF: {
          unit: "pt",
          format: [1200, 750],
          orientation: "landscape",
          ...(override.jsPDF ?? {}),
        },
      };

      // Instead of .save(), get PDF as Blob
      const pdfBlob = await html2pdf()
        .from(container)
        .set(opt)
        .outputPdf("blob");

      // Add PDF blob to zip
      zip.file(`${types[i]} Report - ${address}.pdf`, pdfBlob);
    }

    // Generate the ZIP and download
    const zipBlob = await zip.generateAsync({ type: "blob" });
    this.saveAs(zipBlob);

    // ✅ Optional: clear containers from DOM to free memory
    pages.forEach((el) => el.remove?.());
  }

  static async savePdf(container, type) {
    // Set PDF options
    const opt = {
      margin: 0,
      filename: `${type}-report.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "pt", format: [1200, 750], orientation: "landscape" },
    };

    // Generate PDF
    await html2pdf().from(container).set(opt).save();
    if (window.gc) {
      window.gc(); // Only works with --js-flags="--expose-gc"
    }
  }

  static setupIntroPdf(parser, introHTML, type) {
    const introPage = parser.parseFromString(
      this.introData(introHTML, type),
      "text/html"
    );
    const logoImg = introPage.getElementById("logo-img");
    const bgImg = introPage.getElementById("bg-img");
    logoImg.src = logo;
    bgImg.src = introBgImg;

    const container = document.createElement("div");
    container.style.width = "1200pt";
    container.style.background = "white";

    this.appendPage(container, introPage);
    return container;
  }

  static demographicsRingHTMLMapValues({
    template,
    radiiSetting,
    csvData,
    container,
    parser,
    dataWithSubHeading,
    pageBreaksAfter,
  }) {
    const radii = radiiSetting.map((d) => Number(d.defaultRadius).toFixed(2));
    let newTemplate = this.createRingDemographicsHeader(template, radiiSetting);
    let bodyData = "";

    Object.entries(dataWithSubHeading).forEach(([key, variables]) => {
      bodyData = bodyData.concat(
        this.demographicsSubHeader
          .replace("{{title}}", key)
          .replace("{{length}}", radiiSetting.length + 1)
      );
      const rowTemplateData = variables.map((variable, i) => {
        const rowData = csvData[variable.value];
        let rowTemplate = `<tr ${
          i % 2 === 0 ? "" : 'style="background: #cccccc"'
        }><td>${rowData.DESCRIPTION}</td>`;
        radii.forEach((radius) => {
          rowTemplate = rowTemplate.concat(
            `<td style="text-align: center;">${this.setMeasurement(
              rowData[`RING_${radius}`],
              variable.unit
            )}</td>`
          );
        });
        return rowTemplate.concat("</tr>");
      });
      bodyData = bodyData.concat(rowTemplateData.join(""));
      if (pageBreaksAfter.includes(key)) {
        const doc = parser.parseFromString(
          newTemplate.replace("{{body_data}}", bodyData),
          "text/html"
        );
        const logoImg3 = doc.getElementById("logo-img");
        logoImg3.src = logo;
        this.appendPage(container, doc);
        newTemplate = this.createRingDemographicsHeader(template, radiiSetting);
        bodyData = "";
      }
    });
    const doc = parser.parseFromString(
      newTemplate.replace("{{body_data}}", bodyData),
      "text/html"
    );
    const logoImg3 = doc.getElementById("logo-img");
    logoImg3.src = logo;
    this.appendPage(container, doc);
  }

  static demographicsPolygonHTMLMapValues({
    template,
    title,
    dataKey,
    csvData,
    container,
    parser,
    dataWithSubHeading,
    pageBreaksAfter,
  }) {
    let newTemplate = this.createPolygonDemographicsHeader(template, title);
    let bodyData = "";

    Object.entries(dataWithSubHeading).forEach(([key, variables]) => {
      bodyData = bodyData.concat(
        this.demographicsSubHeader
          .replace("{{title}}", key)
          .replace("{{length}}", 2)
      );
      const rowTemplateData = variables.map((variable, i) => {
        const rowData = csvData[variable.value];
        let rowTemplate = `<tr ${
          i % 2 === 0 ? "" : 'style="background: #cccccc"'
        }><td>${rowData.DESCRIPTION}</td>`;
        rowTemplate = rowTemplate.concat(
          `<td style="text-align: center;">${this.setMeasurement(
            rowData[dataKey],
            variable.unit
          )}</td>`
        );
        return rowTemplate.concat("</tr>");
      });
      bodyData = bodyData.concat(rowTemplateData.join(""));
      if (pageBreaksAfter.includes(key)) {
        const doc = parser.parseFromString(
          newTemplate.replace("{{body_data}}", bodyData),
          "text/html"
        );
        const logoImg3 = doc.getElementById("logo-img");
        logoImg3.src = logo;
        this.appendPage(container, doc);
        newTemplate = this.createPolygonDemographicsHeader(template, title);
        bodyData = "";
      }
    });
    const doc = parser.parseFromString(
      newTemplate.replace("{{body_data}}", bodyData),
      "text/html"
    );
    const logoImg3 = doc.getElementById("logo-img");
    logoImg3.src = logo;
    this.appendPage(container, doc);
  }

  // Fills the new consolidated "Demographics Report" template (one page,
  // 7 stacked tables) from a cr_xp5 demographics CSV. See FEATURE.md in the
  // API repo (location-demogr/FEATURE.md) for the section schema source.
  /**
   * Canada section schema for the consolidated Demographics Report.
   *
   * AGS publishes only `can_crm` and `can_xp1` for Canada — `can_xp3`,
   * `can_xp5` and `can_env` all return ".rpt does not exist" — so the US
   * (cr_xp5) schema cannot be reused: of the 38 codes the US sections need,
   * can_xp1 supplies 5. It is not a renaming either, it is StatCan's own
   * variable set, so the US-only sections (growth/projections, Hispanic
   * origin, occupation, business activity, housing, transportation) have no
   * Canadian counterpart and are dropped rather than shown empty.
   *
   * In exchange can_xp1 carries data the US set does not: single-year age
   * bands, visible-minority counts, language spoken, after-tax household
   * income and StatCan education levels. Labels and groupings below mirror the
   * DESCRIPTION column AGS returns, so the report reads the way AGS labels it.
   *
   * These are counts, not percentages (the US schema is largely percentages),
   * hence fInt almost everywhere.
   */
  static CANADA_DEMOGRAPHICS_SECTIONS = {
    population_households: [
      {
        header: "Population",
        rows: [
          { label: "Population", code: "POPCY", fmt: "fInt" },
          { label: "Male", code: "SEXCYMAL", fmt: "fInt" },
          { label: "Female", code: "SEXCYFEM", fmt: "fInt" },
          // Not in can_xp1; merged in from can_crm when the crime report is
          // also selected, otherwise renders "—". AGS returns it as a whole
          // number here, so fInt (thousands-separated) rather than fDec2.
          { label: "Population Density (Per Sq Mile)", code: "POPCYDENS", fmt: "fInt" },
        ],
      },
      {
        header: "Visible Minority",
        rows: [
          { label: "Visible Minority", code: "POPCYVISM", fmt: "fInt" },
          { label: "Not Visible Minority", code: "POPCYNVISM", fmt: "fInt" },
        ],
      },
      {
        header: "Households",
        rows: [
          { label: "Households", code: "HHDCY", fmt: "fInt" },
          { label: "Couple Families w/o Children", code: "HHDCYCPL0", fmt: "fInt" },
          { label: "Couple Families w Children", code: "HHDCYMCCH", fmt: "fInt" },
          { label: "One Parent Families", code: "HHDCYLPF", fmt: "fInt" },
          { label: "Two+ Families w Individuals", code: "HHDCYNFM", fmt: "fInt" },
        ],
      },
    ],
    age: [
      {
        header: "Population By Age",
        rows: [
          { label: "Age 0-4", code: "AGDCY0004", fmt: "fInt" },
          { label: "Age 5-9", code: "AGDCY0509", fmt: "fInt" },
          { label: "Age 10-14", code: "AGDCY1014", fmt: "fInt" },
          { label: "Age 15-19", code: "AGDCY1519", fmt: "fInt" },
          { label: "Age 20-24", code: "AGDCY2024", fmt: "fInt" },
          { label: "Age 25-29", code: "AGDCY2529", fmt: "fInt" },
          { label: "Age 30-34", code: "AGDCY3034", fmt: "fInt" },
          { label: "Age 35-39", code: "AGDCY3539", fmt: "fInt" },
          { label: "Age 40-44", code: "AGDCY4044", fmt: "fInt" },
          { label: "Age 45-49", code: "AGDCY4549", fmt: "fInt" },
          { label: "Age 50-54", code: "AGDCY5054", fmt: "fInt" },
          { label: "Age 55-59", code: "AGDCY5559", fmt: "fInt" },
          { label: "Age 60-64", code: "AGDCY6064", fmt: "fInt" },
          { label: "Age 65-69", code: "AGDCY6569", fmt: "fInt" },
          { label: "Age 70-74", code: "AGDCY7074", fmt: "fInt" },
          { label: "Age 75-79", code: "AGDCY7579", fmt: "fInt" },
          { label: "Age 80-84", code: "AGDCY8084", fmt: "fInt" },
          { label: "Age 85+", code: "AGDCYGT85", fmt: "fInt" },
          { label: "Median Age", code: "AGECYMED", fmt: "fDec1" },
        ],
      },
    ],
    education: [
      {
        header: "Educational Attainment",
        rows: [
          { label: "Without Secondary", code: "EDUCYNOHS", fmt: "fInt" },
          { label: "With High School", code: "EDUCYHS", fmt: "fInt" },
          { label: "With Post Secondary", code: "EDUCYPOST", fmt: "fInt" },
          { label: "Less Than Bachelors Degree", code: "EDUCYSCOLL", fmt: "fInt" },
          { label: "Trades", code: "EDUCYTRD", fmt: "fInt" },
          { label: "Apprentice Trades", code: "EDUCYAPP", fmt: "fInt" },
          { label: "Non Apprentice Trades", code: "EDUCYNAPP", fmt: "fInt" },
          { label: "College", code: "EDUCYCOLL", fmt: "fInt" },
          { label: "University", code: "EDUCYUNIV", fmt: "fInt" },
          { label: "Bachelors Degree and Above", code: "EDUCYGRAD", fmt: "fInt" },
          { label: "Bachelor Degree", code: "EDUCYBACH", fmt: "fInt" },
          { label: "Certificate Above Bachelor", code: "EDUCYGCERT", fmt: "fInt" },
          { label: "Medical & Dental Doctorate", code: "EDUCYMED", fmt: "fInt" },
          { label: "Masters Degree", code: "EDUCYMAST", fmt: "fInt" },
          { label: "Doctorate Degree", code: "EDUCYPHD", fmt: "fInt" },
        ],
      },
    ],
    income: [
      {
        header: "Income",
        rows: [
          { label: "Average Household Income", code: "INCCYAVEHH", fmt: "fDollar" },
          { label: "Median Household Income", code: "INCCYMEDHH", fmt: "fDollar" },
          { label: "Average Household Disposable Income", code: "INCCYAVDIS", fmt: "fDollar" },
        ],
      },
      {
        header: "Households By Income",
        rows: [
          { label: "< $10,000", code: "HINCYLT10", fmt: "fInt" },
          { label: "$10,000 - $19,999", code: "HINCY1020", fmt: "fInt" },
          { label: "$20,000 - $29,999", code: "HINCY2030", fmt: "fInt" },
          { label: "$30,000 - $39,999", code: "HINCY3040", fmt: "fInt" },
          { label: "$40,000 - $49,999", code: "HINCY4050", fmt: "fInt" },
          { label: "$50,000 - $59,999", code: "HINCY5060", fmt: "fInt" },
          { label: "$60,000 - $69,999", code: "HINCY6070", fmt: "fInt" },
          { label: "$70,000 - $79,999", code: "HINCY7080", fmt: "fInt" },
          { label: "$80,000 - $89,999", code: "HINCY8090", fmt: "fInt" },
          { label: "$90,000 - $99,999", code: "HINCY90100", fmt: "fInt" },
          { label: "$100,000 - $149,999", code: "HINCY10050", fmt: "fInt" },
          { label: "$150,000 - $199,999", code: "HINCY15200", fmt: "fInt" },
          { label: "$200,000+", code: "HINCYGT200", fmt: "fInt" },
        ],
      },
    ],
    labour_force: [
      {
        header: "Labour Force Status",
        rows: [
          { label: "In Labour Force", code: "LBFCYLBF", fmt: "fInt" },
          { label: "Employed", code: "LBFCYEMPL", fmt: "fInt" },
          { label: "Unemployed", code: "LBFCYUNEMP", fmt: "fInt" },
          { label: "Not In Labour Force", code: "LBFCYNILF", fmt: "fInt" },
        ],
      },
    ],
    language: [
      {
        header: "Language Spoken",
        rows: [
          { label: "Single Responses", code: "LNGCYSING", fmt: "fInt" },
          { label: "Official Languages", code: "LNGCYOFF", fmt: "fInt" },
          { label: "English", code: "LNGCYENG", fmt: "fInt" },
          { label: "French", code: "LNGCYFRE", fmt: "fInt" },
          { label: "Non-official Languages", code: "LNGNOFF", fmt: "fInt" },
          { label: "English and French", code: "LNGCYBILEF", fmt: "fInt" },
          { label: "English and Non-official Language(s)", code: "LNGCYBILEO", fmt: "fInt" },
          { label: "French and Non-official Language(s)", code: "LNGCYBILFO", fmt: "fInt" },
          { label: "English, French and Non-official Language(s)", code: "LNGCYBILBO", fmt: "fInt" },
        ],
      },
    ],
  };

  static demographicsReportHTMLMapValues({
    template,
    address,
    ringKeys, // ["RING_0.25", "RING_0.50", "RING_0.75"] ascending
    ringMileLabels, // [".25 Mile Radius", ".50 Mile Radius", ".75 Mile Radius"]
    demoData,
    // Section schema to render. Defaults to the US (cr_xp5) set below; Canada
    // passes CANADA_DEMOGRAPHICS_SECTIONS because can_xp1 is a completely
    // different StatCan variable set (see that field's comment).
    sections: sectionsOverride,
  }) {
    const now = new Date();
    const creationDate = now.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    // Estimate labels use the current calendar year; projections roll to +5.
    // Census columns (2010/2020) stay fixed — those are real historical events.
    const cy = now.getFullYear();
    const py = cy + 5;
    const yearTokens = {
      "{{cy}}": String(cy),
      "{{py}}": String(py),
      "{{cy_to_py}}": `${cy} to ${py}`,
      "{{p10_to_cy}}": `2010 to ${cy}`,
    };

    const isMissing = (v) => v === undefined || v === null || v === "";
    const toNumber = (v) => {
      if (isMissing(v)) return null;
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    };
    const fInt = (v) => {
      const n = toNumber(v);
      return n === null ? "—" : Math.round(n).toLocaleString("en-US");
    };
    const fDec1 = (v) => {
      const n = toNumber(v);
      return n === null ? "—" : n.toFixed(1);
    };
    const fDec2 = (v) => {
      const n = toNumber(v);
      return n === null ? "—" : n.toFixed(2);
    };
    const fDollar = (v) => {
      const n = toNumber(v);
      return n === null
        ? "—"
        : `$${Math.round(n).toLocaleString("en-US")}`;
    };
    const fmt = { fInt, fDec1, fDec2, fDollar };

    // 3-color cycle matches the design's .25/.50/.75 column treatment when
    // exactly 3 rings are requested; for other ring counts we just cycle.
    const colCycle = ["col-orange", "col-mid-orange", "col-light-orange"];
    const theadColumnsHTML = ringMileLabels
      .map((label, i) => `<th class="${colCycle[i % 3]}">${label}</th>`)
      .join("");

    const cardCycle = ["", "mid-orange", "light-orange"];
    const tradeAreaCardsHTML = ringMileLabels
      .map((label, i) => {
        const rk = ringKeys[i];
        const headerCls = cardCycle[i % 3];
        return `
        <div class="trade-area-card">
          <div class="card-header${headerCls ? " " + headerCls : ""}">
            <img src="/reports/location-demographics/assets/card-symbol.svg" alt="" />
            <h2 class="card-header-title">${label}</h2>
          </div>
          <div class="card-body">
            <div class="card-body-item">
              <p>{{cy}} ESTIMATED POPULATION</p>
              <p>${fInt(demoData["POPCY"]?.[rk])}</p>
            </div>
            <div class="card-body-item">
              <p>MEDIAN AGE</p>
              <p>${fDec1(demoData["AGECYMED"]?.[rk])}</p>
            </div>
            <div class="card-body-item">
              <p>AVERAGE HOUSEHOLD INCOME</p>
              <p>${fDollar(demoData["INCCYAVEHH"]?.[rk])}</p>
            </div>
          </div>
        </div>`;
      })
      .join("");

    const colspan = ringKeys.length + 1;
    const buildTbody = (subsections) => {
      let html = "";
      subsections.forEach((sub) => {
        html += `<tr class="section-divider-row"><td colspan="${colspan}">${sub.header}</td></tr>`;
        sub.rows.forEach((row, i) => {
          const cls = i % 2 === 1 ? ' class="alt-row"' : "";
          let cells = `<td>${row.label}</td>`;
          ringKeys.forEach((rk) => {
            const formatter = fmt[row.fmt] ?? fDec2;
            cells += `<td>${formatter(demoData[row.code]?.[rk])}</td>`;
          });
          html += `<tr${cls}>${cells}</tr>`;
        });
      });
      return html;
    };

    const usSections = {
      population_growth: [
        {
          header: "Population",
          rows: [
            { label: "{{cy}} Estimated Population", code: "POPCY", fmt: "fInt" },
            { label: "{{py}} Projected Population", code: "POPPY", fmt: "fInt" },
            { label: "2020 Census Population", code: "POP20", fmt: "fInt" },
            { label: "2010 Census Population", code: "POP10", fmt: "fInt" },
            { label: "Projected Annual Growth {{cy_to_py}}", code: "GROWCYPY", fmt: "fDec2" },
            { label: "Historical Annual Growth {{p10_to_cy}}", code: "GROW10CY", fmt: "fDec2" },
            { label: "Population Density Per Sq Mile", code: "PDENS", fmt: "fDec2" },
          ],
        },
        {
          header: "Non-Residents",
          rows: [
            { label: "Average Annual Non-Resident Population", code: "NRPCYTTOT", fmt: "fInt" },
            { label: "Average Annual Non-Residents At Hotels", code: "NRPCYTHTL", fmt: "fInt" },
          ],
        },
        {
          header: "Households",
          rows: [
            { label: "{{cy}} Estimated Households", code: "HHDCY", fmt: "fInt" },
            { label: "{{py}} Estimated Households", code: "HHDPY", fmt: "fInt" },
            { label: "2020 Census Households", code: "HHD20", fmt: "fInt" },
            { label: "2010 Census Households", code: "HHD10", fmt: "fInt" },
            { label: "Projected Annual Growth {{cy_to_py}}", code: "HGRWCYPY", fmt: "fDec2" },
            { label: "Historical Annual Growth {{p10_to_cy}}", code: "HGRW10CY", fmt: "fDec2" },
          ],
        },
      ],
      age_marital: [
        {
          header: "Age",
          rows: [
            { label: "Under Age 5", code: "Child5", fmt: "fDec2" },
            { label: "Age 5-17", code: "Child17", fmt: "fDec2" },
            { label: "Age 18-29", code: "A1829", fmt: "fDec2" },
            { label: "Age 30-44", code: "A3044", fmt: "fDec2" },
            { label: "Age 45-64", code: "A4564", fmt: "fDec2" },
            { label: "Age 65-74", code: "A6574", fmt: "fDec2" },
            { label: "Age 75+", code: "AGT75", fmt: "fDec2" },
            { label: "Median Age", code: "AGECYMED", fmt: "fDec1" },
          ],
        },
        {
          header: "Marital Status and Gender",
          rows: [
            { label: "Male", code: "S1", fmt: "fDec2" },
            { label: "Female", code: "S2", fmt: "fDec2" },
            { label: "Never Married", code: "MAR1", fmt: "fDec2" },
            { label: "Now Married", code: "MAR2", fmt: "fDec2" },
            { label: "Separated or Divorced", code: "MAR3", fmt: "fDec2" },
            { label: "Widowed", code: "MAR4", fmt: "fDec2" },
          ],
        },
      ],
      race_education: [
        {
          header: "Race",
          rows: [
            { label: "Non-Hispanic White", code: "RC1", fmt: "fDec2" },
            { label: "Non-Hispanic Black", code: "RC2", fmt: "fDec2" },
            { label: "Non-Hispanic Asian", code: "RC3", fmt: "fDec2" },
            { label: "Non-Hispanic Native American", code: "RC4", fmt: "fDec2" },
            { label: "Non-Hispanic Hawaiian/Pacific Islander", code: "RC5", fmt: "fDec2" },
            { label: "Non-Hispanic Other and Multiple", code: "RC6", fmt: "fDec2" },
            { label: "Hispanic, Any Race", code: "RC7", fmt: "fDec2" },
            { label: "Hispanic Population {{cy}}", code: "RC8", fmt: "fInt" },
            { label: "Hispanic Population {{py}}", code: "HISPYHISP", fmt: "fInt" },
            { label: "Hispanic Population Census 2020", code: "HIS20HISP", fmt: "fInt" },
          ],
        },
        {
          header: "Education (Age 25+)",
          rows: [
            { label: "Less than 9th Grade", code: "E1", fmt: "fDec2" },
            { label: "Some High School", code: "E2", fmt: "fDec2" },
            { label: "High School Graduate", code: "E3", fmt: "fDec2" },
            { label: "Some College", code: "E4", fmt: "fDec2" },
            { label: "Associate Degree", code: "E5", fmt: "fDec2" },
            { label: "Bachelor's Degree", code: "E6", fmt: "fDec2" },
            { label: "Graduate or Professional Degree", code: "E7", fmt: "fDec2" },
          ],
        },
      ],
      income: [
        {
          header: "Income",
          rows: [
            { label: "Average household Income", code: "INCCYAVEHH", fmt: "fInt" },
            { label: "Median household income", code: "INCCYMEDHH", fmt: "fInt" },
            { label: "Per capita income", code: "INCCYPCAP", fmt: "fInt" },
            { label: "< $10,000", code: "I1", fmt: "fDec2" },
            { label: "$10,000 - $24,999", code: "I2", fmt: "fDec2" },
            { label: "$25,000 - $49,999", code: "I3", fmt: "fDec2" },
            { label: "$50,000 - $74,999", code: "I4", fmt: "fDec2" },
            { label: "$75,000 - $99,999", code: "I5", fmt: "fDec2" },
            { label: "$100,000 - $124,999", code: "I6", fmt: "fDec2" },
            { label: "$125,000 - $149,999", code: "I7", fmt: "fDec2" },
            { label: "$150,000 - $199,999", code: "I8", fmt: "fDec2" },
            { label: "$200,000 - $249,999", code: "I9", fmt: "fDec2" },
            { label: "$250,000 - $499,999", code: "I10", fmt: "fDec2" },
            { label: "> $500,000", code: "I11", fmt: "fDec2" },
          ],
        },
      ],
      housing_occupancy: [
        {
          header: "Housing",
          rows: [
            { label: "Housing units", code: "DWLCY", fmt: "fInt" },
            { label: "Owner Occupied", code: "HOU1", fmt: "fDec2" },
            { label: "Renter Occupied", code: "HOU2", fmt: "fDec2" },
            { label: "Vacant", code: "HOU3", fmt: "fDec2" },
          ],
        },
        {
          header: "Housing Type",
          rows: [
            { label: "Single Family Detached", code: "HT1", fmt: "fDec2" },
            { label: "Single Family Attached", code: "HT2", fmt: "fDec2" },
            { label: "2-4 Units in Structure", code: "HT3", fmt: "fDec2" },
            { label: "5-20 Units in Structure", code: "HT4", fmt: "fDec2" },
            { label: "20+ Units in Structure", code: "HT5", fmt: "fDec2" },
            { label: "Mobile Home", code: "HT6", fmt: "fDec2" },
            { label: "Other Housing", code: "HT7", fmt: "fDec2" },
          ],
        },
        {
          header: "Homes Built by Year",
          rows: [
            { label: "After 2010", code: "Y1", fmt: "fDec2" },
            { label: "2000 to 2010", code: "Y2", fmt: "fDec2" },
            { label: "1990 to 2000", code: "Y3", fmt: "fDec2" },
            { label: "1980 to 1990", code: "Y4", fmt: "fDec2" },
            { label: "1970 to 1980", code: "Y5", fmt: "fDec2" },
            { label: "1960 to 1970", code: "Y6", fmt: "fDec2" },
            { label: "1950 to 1960", code: "Y7", fmt: "fDec2" },
            { label: "Before 1950", code: "Y8", fmt: "fDec2" },
            { label: "Median Housing Age", code: "YBTEXMED", fmt: "fDec2" },
            { label: "Median Age of Renter Occupied Dwellings", code: "YR", fmt: "fDec2" },
          ],
        },
        {
          header: "Home Values",
          rows: [
            { label: "Over $1,000,000", code: "V1", fmt: "fDec2" },
            { label: "$500,000 to $999,999", code: "V2", fmt: "fDec2" },
            { label: "$400,000 to $499,999", code: "V3", fmt: "fDec2" },
            { label: "$300,000 to $399,999", code: "V4", fmt: "fDec2" },
            { label: "$200,000 to $299,999", code: "V5", fmt: "fDec2" },
            { label: "$150,000 to $199,999", code: "V6", fmt: "fDec2" },
            { label: "$100,000 to $149,999", code: "V7", fmt: "fDec2" },
            { label: "$50,000 to $99,999", code: "V8", fmt: "fDec2" },
            { label: "Under $50,000", code: "V9", fmt: "fDec2" },
          ],
        },
        {
          header: "Business Activity",
          rows: [
            { label: "Total Establishments", code: "BUSCYEST", fmt: "fInt" },
            { label: "Total Employees", code: "BUSCYEMP", fmt: "fInt" },
            { label: "Average Employees Per Business", code: "AVESZ", fmt: "fDec2" },
            { label: "Residential Population Per Business", code: "AVERE", fmt: "fDec2" },
          ],
        },
      ],
      occupation: [
        {
          header: "Occupation",
          rows: [
            { label: "Management, Business & Financial Operations", code: "OCC1", fmt: "fDec2" },
            { label: "Professional and Related", code: "OCC2", fmt: "fDec2" },
            { label: "Health Care", code: "OCC3", fmt: "fDec2" },
            { label: "Protective Services", code: "OCC4", fmt: "fDec2" },
            { label: "Other Services", code: "OCC5", fmt: "fDec2" },
            { label: "Sales and Office", code: "OCC6", fmt: "fDec2" },
            { label: "Farming, Fishing and Forestry", code: "OCC7", fmt: "fDec2" },
            { label: "Construction and Extraction", code: "OCC8", fmt: "fDec2" },
            { label: "Installation, Maintenance and Repair", code: "OCC9", fmt: "fDec2" },
            { label: "Production", code: "OCC10", fmt: "fDec2" },
            { label: "Transportation and Material Moving", code: "OCC11", fmt: "fDec2" },
            { label: "White Collar Occupations", code: "OCC12", fmt: "fDec2" },
            { label: "Blue Collar Occupations", code: "OCC13", fmt: "fDec2" },
          ],
        },
        {
          header: "Labor Force",
          rows: [
            { label: "Population Age 16+", code: "LBFCYPOP16", fmt: "fInt" },
            { label: "Civilian Employed", code: "L1", fmt: "fDec2" },
            { label: "Civilian Unemployed", code: "L2", fmt: "fDec2" },
            { label: "In Armed Forces", code: "L3", fmt: "fDec2" },
            { label: "Not in Labor Force", code: "L4", fmt: "fDec2" },
            { label: "Labor Force Males", code: "LM1", fmt: "fDec2" },
            { label: "Labor Force Females", code: "LF1", fmt: "fDec2" },
          ],
        },
      ],
      transportation: [
        {
          header: "Transportation to Work",
          rows: [
            { label: "Drove Alone", code: "TRN1", fmt: "fDec2" },
            { label: "Carpool", code: "TRN2", fmt: "fDec2" },
            { label: "Public Transportation", code: "TRN3", fmt: "fDec2" },
            { label: "Motorcycle", code: "TRN4", fmt: "fDec2" },
            { label: "Walk, Bicycle or Other", code: "TRN5", fmt: "fDec2" },
            { label: "Work at Home", code: "TRN6", fmt: "fDec2" },
            { label: "Median Travel Time to Work", code: "TVWEXMED", fmt: "fDec2" },
          ],
        },
      ],
    };

    const sections = sectionsOverride ?? usSections;

    let filled = template
      .replace(/{{address}}/g, address ?? "")
      .replace(/{{creation_date}}/g, creationDate)
      .replace(/{{trade_area_cards}}/g, tradeAreaCardsHTML)
      .replace(/{{thead_columns}}/g, theadColumnsHTML);

    // Each section key fills `{{tbody_<key>}}`, so a template only has to name
    // the sections it wants — that's what lets the US and Canada schemas share
    // this renderer without a second copy of the machinery.
    for (const [key, subsections] of Object.entries(sections)) {
      filled = filled
        .split(`{{tbody_${key}}}`)
        .join(buildTbody(subsections));
    }

    // Apply year tokens last so labels inside the schema (e.g. "{{cy}}
    // Estimated Population") are resolved alongside the template's own.
    for (const [token, value] of Object.entries(yearTokens)) {
      filled = filled.split(token).join(value);
    }

    return filled;
  }

  static async convertRadiusRingToCrimeRiskPdf({
    activeMarker,
    mapRef,
    csvData,
    markerRef,
    country,
    selectedReports = [],
  }) {
    const containersList = [];
    const typesList = [];

    const availableCSVNames = Object.keys(csvData);

    const parser = new DOMParser();
    const introHTML = await this.fetchHTML("/intro-page.html");

    const radiiSettings = activeMarker.radiusSetting.filter(
      (d) => d.type === RadiusTypeEnum.RADIUS_RING
    );

    if (
      availableCSVNames.includes("crime") ||
      availableCSVNames.includes("canada_crime")
    ) {
      const keyName = availableCSVNames.includes("crime")
        ? "crime"
        : "canada_crime";
      const crimeDataMap = {};
      csvData[keyName].forEach((d) => {
        crimeDataMap[d.VARIABLE] = { ...d };
      });

      const demoDataMap = {};
      ["demographics_5", "demographics_3", "demographics_1"].forEach((k) => {
        if (csvData[k]) {
          csvData[k].forEach((d) => {
            if (!demoDataMap[d.VARIABLE]) {
              demoDataMap[d.VARIABLE] = { ...d };
            }
          });
        }
      });

      // Ring map layers are named `circleData-<i>-<lng>-<lat>` where <i> is the
      // index into activeMarker.radiusSetting (see RadiusRingSelector.js and
      // MarkerStyleSettings.js) — NOT the position in the ring-only or sorted
      // list. Carry the original index so the right layers get hidden; deriving
      // it from a filtered array's index silently targets the wrong rings once
      // a drive-time entry sits among them.
      const ringEntries = activeMarker.radiusSetting
        .map((setting, radiusSettingIndex) => ({ setting, radiusSettingIndex }))
        .filter((d) => d.setting.type === RadiusTypeEnum.RADIUS_RING);

      const sortedRings = [...ringEntries].sort(
        (a, b) =>
          parseFloat(a.setting.defaultRadius) -
          parseFloat(b.setting.defaultRadius)
      );

      const lngLat = [activeMarker.latlng.lng, activeMarker.latlng.lat];
      const ringLayerIdsFor = (entry) => [
        `circleData-${entry.radiusSettingIndex}-${lngLat[0]}-${lngLat[1]}`,
        `circleData-${entry.radiusSettingIndex}-${lngLat[0]}-${lngLat[1]}-line`,
      ];

      // .page in crime-risk-cover/projections.html is width: 1200px, height:
      // 750px — container must match in CSS pixels, otherwise html2canvas
      // captures the surrounding whitespace and the final PDF has a dead
      // right-hand strip. (Existing reports use "1200pt" because their
      // templates have no explicit page width and fill the container.)
      const container = document.createElement("div");
      container.style.width = "1200px";
      container.style.background = "white";
      // Tell generatePDFsAndZip to size the PDF page in CSS pixels too,
      // so the 1200×750 CSS-px .page fills the PDF page exactly. Default
      // `unit: "pt"` with same numbers gives a 1200pt page (~33% larger
      // than the canvas natural size) leaving dead whitespace.
      container.__pdfOpt = {
        jsPDF: { unit: "px", format: [1200, 750], orientation: "landscape" },
      };

      const coverHTML = await this.fetchHTML("/reports/crime/cover.html");
      // .map-container in crime-risk-cover.html is roughly 800×285 CSS px
      // (score-right column at ~800px wide, flex space after stats-bar and
      // bottom-tables). 800 / 285 ≈ 2.8. Capturing the ring at this aspect
      // means object-fit doesn't need to crop anything in the report.
      const COVER_MAP_ASPECT = 2.8;

      // One cover page per selected ring — US and Canada alike. Sequential on
      // purpose: each iteration re-fits the shared map and screenshots it, so
      // these cannot overlap.
      for (const ringEntry of sortedRings) {
        const ring = ringEntry.setting;
        const ringKey = `RING_${Number(ring.defaultRadius).toFixed(2)}`;

        markerRef.forEach((m) => {
          if (m.id.includes("circleData")) {
            m.marker.getElement().style.display = "none";
          }
        });

        const circle = turf.circle(
          turf.point(lngLat),
          parseFloat(ring.defaultRadius),
          { units: "miles" }
        );
        const imgUrls = [];
        await this.captureCircleArea({
          map: mapRef,
          // Hide every OTHER ring so this page's map shows only its own radius.
          // captureCircleArea restores them before it resolves.
          circleLayerIds: sortedRings
            .filter(
              (o) => o.radiusSettingIndex !== ringEntry.radiusSettingIndex
            )
            .flatMap(ringLayerIdsFor),
          coordinates: circle,
          imgUrls,
          targetAspect: COVER_MAP_ASPECT,
        });

        markerRef.forEach((m) => {
          if (m.id.includes("circleData")) {
            m.marker.getElement().style.display = "";
          }
        });

        const coverFilled = this.crimeRiskCoverHTMLMapValues({
          template: coverHTML,
          address: activeMarker.name,
          ringLabel: this.formatRingLabel(ring.defaultRadius),
          ringKey,
          crimeData: crimeDataMap,
          demoData: demoDataMap,
          country,
        });
        const coverDoc = parser.parseFromString(coverFilled, "text/html");
        await this.inlineStylesheets(coverDoc);
        const coverLogo = coverDoc.getElementById("logo-img");
        if (coverLogo) coverLogo.src = logo;
        const coverImg = coverDoc.getElementById("radius-ring-img");
        if (coverImg && imgUrls[0]) coverImg.src = imgUrls[0];
        // Strip box-shadow on .page to stop it adding ~48px overflow that
        // html2pdf would push onto a second blank page in screen media.
        coverDoc
          .querySelectorAll(".page")
          .forEach((el) => (el.style.boxShadow = "none"));
        // Don't add an explicit html2pdf__page-break div here. The template's
        // `.page` rule already has `@media print { page-break-after: always }`,
        // which html2pdf honors. Adding our own div stacks two breaks and
        // inserts a blank page in between.
        this.appendPage(container, coverDoc, { addPageBreak: false });
      }

      const normalizedCountry = (country ?? "").toString().toLowerCase();
      const isUS =
        normalizedCountry === "" ||
        normalizedCountry === "usa" ||
        normalizedCountry === "us";

      // Canada is intentionally excluded: AGS's can_crm varlist returns no
      // projection variables at all (no CRMPY*/GRADEPY rows), so there is
      // nothing to plot. Canada reports are cover pages only.
      if (isUS) {
        const projHTML = await this.fetchHTML(
          "/reports/crime/projections.html"
        );
        const projFilled = this.crimeRiskProjectionsHTMLMapValues({
          template: projHTML,
          address: activeMarker.name,
          // Only the three smallest rings — more columns than that don't fit
          // the 1200px page legibly. Cover pages above still cover every ring.
          rings: sortedRings
            .slice(0, this.PROJECTION_MAX_RINGS)
            .map((d) => d.setting),
          crimeData: crimeDataMap,
          country,
        });
        const projDoc = parser.parseFromString(projFilled, "text/html");
        await this.inlineStylesheets(projDoc);
        const projLogo = projDoc.getElementById("logo-img");
        if (projLogo) projLogo.src = logo;
        projDoc
          .querySelectorAll(".page")
          .forEach((el) => (el.style.boxShadow = "none"));
        // Every .page carries `page-break-after: always` in print media, so the
        // N cover pages above plus this one paginate on their own — no explicit
        // break div, which would stack two breaks and insert a blank page.
        this.appendPage(container, projDoc, { addPageBreak: false });
      }

      containersList.push(container);
      typesList.push("Crime");
    }
    const demographicsHTML = await this.fetchHTML("/demographics-page.html");

    if (availableCSVNames.includes("environment")) {
      const container = this.setupIntroPdf(parser, introHTML, "environment");
      const mappedCSVData = {};
      csvData["environment"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = [
        "Cooling and Heating Degree Days",
        "Environmental Risks",
      ];
      this.demographicsRingHTMLMapValues({
        template: demographicsHTML
          .replace(
            "{{demographics_header}}",
            "Environmental Risk and Topography"
          )
          .replace("{{address}}", activeMarker.name),
        radiiSetting: radiiSettings,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.environmentDataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Environment");
    }

    // Legacy "Demographic Complete" — only render when the user actually
    // picked cr_xp5 in the picker. The new "Demographics Report" shares
    // the same source CSV, so without this gate selecting just the new
    // report would also produce the legacy PDF. Empty selectedReports
    // (legacy callers) falls through to the old CSV-presence behavior.
    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp5")) &&
      availableCSVNames.includes("demographics_5")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      csvData["demographics_5"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = [
        "Age",
        "Education (Age 25+)",
        "Housing Type",
        "Business",
        "Occupation",
      ];
      this.demographicsRingHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Complete")
          .replace("{{address}}", activeMarker.name),
        radiiSetting: radiiSettings,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.demographics5DataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Demographic Complete");
    }

    // Canada (can_xp1 / canada_demographics_1) is deliberately NOT handled here
    // any more — it renders through the consolidated "Demographics Report"
    // below, matching the US. Leaving it in produced two PDFs for one
    // selection: this legacy "Demographic Essentials" page plus the new one.
    // The polygon path still routes Canada here, because the consolidated
    // report is ring-only for the US too.
    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp3")) &&
      availableCSVNames.includes("demographics_3")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      csvData["demographics_3"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      this.demographicsRingHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Essentials")
          .replace("{{address}}", activeMarker.name),
        radiiSetting: radiiSettings,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.demographics5DataWithSubHeading,
        pageBreaksAfter: [
          "Age",
          "Education (Age 25+)",
          "Housing Type",
          "Business",
          "Occupation",
        ],
      });
      containersList.push(container);
      typesList.push("Demographic Essentials");
    }

    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp1")) &&
      availableCSVNames.includes("demographics_1")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      csvData["demographics_1"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = ["Education (Age 25+)"];
      this.demographicsRingHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Overview")
          .replace("{{address}}", activeMarker.name),
        radiiSetting: radiiSettings,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.demographics1DataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Demographic Overview");
    }

    // New consolidated "Demographics Report" — eventually replaces
    // Overview/Essentials/Complete. UI surfaces it via the synthetic
    // referenceName "demographics_report" (mapped to cr_xp5 server-side),
    // so it only renders when the user explicitly selected it.
    //
    // Canada arrives at the same report via can_xp1 instead: AGS publishes no
    // Canadian cr_xp5 equivalent (can_xp3/can_xp5 return ".rpt does not
    // exist"), so it renders with the Canada template + section schema. Both
    // share the stylesheet and assets, so the two read identically.
    const wantsUsDemographicsReport =
      selectedReports.includes("demographics_report") &&
      availableCSVNames.includes("demographics_5");
    const wantsCanadaDemographicsReport =
      (selectedReports.length === 0 || selectedReports.includes("can_xp1")) &&
      availableCSVNames.includes("canada_demographics_1");

    if (wantsUsDemographicsReport || wantsCanadaDemographicsReport) {
      const isCanadaDemographics = wantsCanadaDemographicsReport;
      const demoCsvKey = isCanadaDemographics
        ? "canada_demographics_1"
        : "demographics_5";

      const demoDataMap = {};
      csvData[demoCsvKey].forEach((d) => {
        if (d.VARIABLE && !demoDataMap[d.VARIABLE]) {
          demoDataMap[d.VARIABLE] = { ...d };
        }
      });
      // Population density is in can_crm, not can_xp1. Fold the crime CSV in
      // behind can_xp1 (first-write-wins above) so density fills in when the
      // crime report was requested too, and renders "—" when it wasn't.
      if (isCanadaDemographics && csvData["canada_crime"]) {
        csvData["canada_crime"].forEach((d) => {
          if (d.VARIABLE && !demoDataMap[d.VARIABLE]) {
            demoDataMap[d.VARIABLE] = { ...d };
          }
        });
      }

      const sortedRings = [...radiiSettings].sort(
        (a, b) => parseFloat(a.defaultRadius) - parseFloat(b.defaultRadius)
      );
      const ringKeys = sortedRings.map(
        (r) => `RING_${Number(r.defaultRadius).toFixed(2)}`
      );
      const ringMileLabels = sortedRings.map(
        (r) => `${Number(r.defaultRadius).toFixed(2)} Mile Radius`
      );

      const demoReportHTML = await this.fetchHTML(
        isCanadaDemographics
          ? "/reports/location-demographics-canada/report.html"
          : "/reports/location-demographics/report.html"
      );
      const filled = this.demographicsReportHTMLMapValues({
        template: demoReportHTML,
        address: activeMarker.name,
        ringKeys,
        ringMileLabels,
        demoData: demoDataMap,
        sections: isCanadaDemographics
          ? this.CANADA_DEMOGRAPHICS_SECTIONS
          : undefined,
      });
      const doc = parser.parseFromString(filled, "text/html");
      await this.inlineStylesheets(doc);
      const logoImgDR = doc.getElementById("logo-img");
      if (logoImgDR) logoImgDR.src = logo;

      // The new template is one continuous long page (no internal page
      // breaks, mirroring the Figma source). Match the PDF canvas to the
      // rendered DOM in CSS pixels so html2pdf produces a single tall
      // page rather than chopping into A4 slices. Height is measured
      // after layout, not hardcoded.
      const container = document.createElement("div");
      container.style.width = "1200px";
      container.style.background = "white";
      this.appendPage(container, doc, { addPageBreak: false });

      // Attach the container in-flow but hidden so the browser computes
      // a proper layout we can measure. We *cannot* use left: -99999px
      // or position: fixed here — html2canvas (under html2pdf) reads the
      // source element's bounding rect and ends up capturing an offscreen
      // empty region, which is what was producing the blank PDF.
      const savedPosition = container.style.position;
      const savedVisibility = container.style.visibility;
      const savedPointerEvents = container.style.pointerEvents;
      const savedZIndex = container.style.zIndex;
      container.style.position = "absolute";
      container.style.top = "0";
      container.style.left = "0";
      container.style.visibility = "hidden";
      container.style.pointerEvents = "none";
      container.style.zIndex = "-1";
      document.body.appendChild(container);

      // Wait for any <img> to finish loading before measuring — SVGs
      // sized purely by CSS won't move layout, but this guards against
      // any image with intrinsic dimensions sizing in late.
      const imgs = Array.from(container.querySelectorAll("img"));
      await Promise.all(
        imgs.map((img) =>
          img.complete && img.naturalWidth !== 0
            ? Promise.resolve()
            : new Promise((res) => {
                img.addEventListener("load", res, { once: true });
                img.addEventListener("error", res, { once: true });
              })
        )
      );

      // Prefer the .page element's bounding height — that's the actual
      // visible report frame. Falling back to container.scrollHeight
      // overcounts because the wrapper picks up incidental layout
      // (the inlined <style> tag, the body innerHTML's outer margin
      // collapse, the .page-body's margin-bottom), which compounds into
      // tens of extra px and shows up as a blank stripe at the bottom
      // of the PDF.
      const pageEl = container.querySelector(".page");
      const measuredHeight = pageEl
        ? pageEl.getBoundingClientRect().height
        : Math.max(
            container.scrollHeight,
            container.getBoundingClientRect().height
          );
      const pageHeight = Math.max(750, Math.ceil(measuredHeight));
      console.log(
        "[demographics-report] measured page height:",
        pageHeight,
        pageEl ? "(from .page)" : "(from container fallback)"
      );

      // Detach + restore styles so html2pdf renders a clean, in-flow
      // element from origin (0, 0). generatePDFsAndZip's later
      // container.remove() is a no-op on an unattached node.
      document.body.removeChild(container);
      container.style.position = savedPosition;
      container.style.top = "";
      container.style.left = "";
      container.style.visibility = savedVisibility;
      container.style.pointerEvents = savedPointerEvents;
      container.style.zIndex = savedZIndex;

      container.__pdfOpt = {
        jsPDF: {
          unit: "px",
          format: [1200, pageHeight],
          orientation: "portrait",
        },
      };

      containersList.push(container);
      typesList.push("Demographics Report");
    }

    await this.generatePDFsAndZip(containersList, typesList, activeMarker.name);
  }

  static async convertPolygonToCrimeRiskPdf({
    activeMarker,
    mapRef,
    csvData,
    markerRef,
    country,
    selectedReports = [],
  }) {
    const containersList = [];
    const typesList = [];

    const availableCSVNames = Object.keys(csvData);
    const dataKey = activeMarker.name.replaceAll(" ", "_").toUpperCase();

    const parser = new DOMParser();
    const introHTML = await this.fetchHTML("/intro-page.html");

    if (
      availableCSVNames.includes("crime") ||
      availableCSVNames.includes("canada_crime")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "crime");
      const imgUrls = [];

      const polygonGeoJSON = {
        type: "Polygon",
        coordinates: activeMarker.polygonCoordinates,
      };
      await this.capturePolygonArea({
        map: mapRef,
        polygonGeoJSON,
        hiddenLayerIds: ["my-layer-id"],
        imgUrls,
      });
      const crimeHTML = await this.fetchHTML("/crime-page-polygon.html");
      const mappedCSVData = {};
      const keyName = availableCSVNames.includes("canada_crime")
        ? "canada_crime"
        : "crime";
      csvData[keyName].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const doc2 = parser.parseFromString(
        this.crimePolygonHTMLMapValues(
          crimeHTML.replace("{{address}}", activeMarker.name),
          dataKey,
          mappedCSVData
        ),
        "text/html"
      );
      const logoImg2 = doc2.getElementById("logo-img");
      const radiusRingImg2 = doc2.getElementById("radius-ring-img");
      radiusRingImg2.src = imgUrls[0];
      logoImg2.src = logo;
      this.appendPage(container, doc2);
      containersList.push(container);
      typesList.push("Crime");
    }
    const demographicsHTML = await this.fetchHTML(
      "/demographics-page-polygon.html"
    );

    if (availableCSVNames.includes("environment")) {
      const container = this.setupIntroPdf(parser, introHTML, "environment");
      const mappedCSVData = {};
      csvData["environment"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = [
        "Cooling and Heating Degree Days",
        "Environmental Risks",
      ];
      this.demographicsPolygonHTMLMapValues({
        template: demographicsHTML
          .replace(
            "{{demographics_header}}",
            "Environmental Risk and Topography"
          )
          .replace("{{address}}", activeMarker.name),
        title: activeMarker.name,
        dataKey,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.environmentDataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Environment");
    }

    // Legacy "Demographic Complete" — only render when the user actually
    // picked cr_xp5 in the picker. The new "Demographics Report" shares
    // the same source CSV, so without this gate selecting just the new
    // report would also produce the legacy PDF. Empty selectedReports
    // (legacy callers) falls through to the old CSV-presence behavior.
    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp5")) &&
      availableCSVNames.includes("demographics_5")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      csvData["demographics_5"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = [
        "Age",
        "Education (Age 25+)",
        "Housing Type",
        "Business",
        "Occupation",
      ];
      this.demographicsPolygonHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Complete")
          .replace("{{address}}", activeMarker.name),
        title: activeMarker.name,
        dataKey,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.demographics5DataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Demographic Complete");
    }

    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp3") ||
        selectedReports.includes("can_xp1")) &&
      (availableCSVNames.includes("demographics_3") ||
        availableCSVNames.includes("canada_demographics_1"))
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      const keyName = availableCSVNames.includes("canada_demographics_1")
        ? "canada_demographics_1"
        : "demographics_3";
      csvData[keyName].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter =
        keyName === "canada_demographics_1"
          ? [
              "Population By Age",
              "Educational Attainment",
              "Labour Force Status",
            ]
          : [
              "Age",
              "Education (Age 25+)",
              "Housing Type",
              "Business",
              "Occupation",
            ];
      this.demographicsPolygonHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Essentials")
          .replace("{{address}}", activeMarker.name),
        title: activeMarker.name,
        dataKey,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading:
          keyName === "canada_demographics_1"
            ? this.canadaDemographicsDataWithSubHeading
            : this.demographics5DataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Demographic Essentials");
    }

    if (
      (selectedReports.length === 0 ||
        selectedReports.includes("cr_xp1")) &&
      availableCSVNames.includes("demographics_1")
    ) {
      const container = this.setupIntroPdf(parser, introHTML, "demographics");
      const mappedCSVData = {};
      csvData["demographics_1"].forEach((d) => {
        mappedCSVData[d.VARIABLE] = {
          ...d,
        };
      });
      const pageBreaksAfter = ["Education (Age 25+)"];
      this.demographicsPolygonHTMLMapValues({
        template: demographicsHTML
          .replace("{{demographics_header}}", "Demographic Overview")
          .replace("{{address}}", activeMarker.name),
        title: activeMarker.name,
        dataKey,
        csvData: mappedCSVData,
        container,
        parser,
        dataWithSubHeading: this.demographics1DataWithSubHeading,
        pageBreaksAfter,
      });
      containersList.push(container);
      typesList.push("Demographic Overview");
    }
    await this.generatePDFsAndZip(containersList, typesList, activeMarker.name);
  }
}
